import React, { useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { cn } from "../../utils";
import { Container } from "./Container";
import { PageContext } from "./PageContext";
import { SPACING } from "../../config/layout";
import { isWorkspaceLayoutPath } from "@/lib/constants/routes";

interface PageLayoutProps {
  children: React.ReactNode;
  title?: string;
  description?: string;
}

export const PageLayout: React.FC<PageLayoutProps> = ({ children }) => {
  const location = useLocation();
  const context = useContext(PageContext);
  const config = context?.config;

  useEffect(() => {
    context?.resetConfig?.();
  }, [location.pathname]); // eslint-disable-line react-hooks/exhaustive-deps -- run only on pathname

  const isHubPage = isWorkspaceLayoutPath(location.pathname);

  const outerPaddingClass = cn("flex-1", SPACING.PAGE_PADDING_Y);

  const fullBleed = config?.fullBleed === true || isHubPage;

  return (
    <div className={cn(fullBleed ? "flex min-h-0 flex-1 flex-col overflow-hidden" : "min-h-full")}>
      {fullBleed ? (
        <div className="flex min-h-0 flex-1 flex-col overflow-hidden h-full min-h-[60vh]">{children}</div>
      ) : (
        <div className={outerPaddingClass}>
          <Container maxWidth="custom">{children}</Container>
        </div>
      )}
    </div>
  );
};

export default PageLayout;
